import axios from 'axios'
import router from '@/router'
import store from '@/store'
import {
  getToken,
  getTokenExpiresAt,
  removeToken,
  saveAuthToken,
} from '@/utils/auth'

const REFRESH_BEFORE_MS = 6 * 60 * 60 * 1000
const REFRESH_TOKEN_URL = 'https://danmuadmin.wokfoy.com/api/user/refresh-token'
const REFRESH_TOKEN_PATH = '/api/user/refresh-token'

let refreshPromise = null
let redirectingToLogin = false

function parseExpiresAt(value) {
  if (!value) return null
  const ts = Date.parse(String(value).replace(/-/g, '/'))
  return Number.isNaN(ts) ? null : ts
}

export function getCurrentAdminToken() {
  return store.getters.token || getToken()
}

export function isRefreshTokenRequest(config = {}) {
  const url = String(config.url || '')
  return url.includes(REFRESH_TOKEN_PATH)
}

export function shouldRefreshAdminToken() {
  const token = getCurrentAdminToken()
  if (!token) return false
  const expiresAt = parseExpiresAt(getTokenExpiresAt())
  if (!expiresAt) return false
  return expiresAt - Date.now() < REFRESH_BEFORE_MS
}

export function applyAdminToken(data = {}) {
  if (!data.token) return ''
  saveAuthToken(data)
  store.commit('SET_TOKEN', data.token)
  try {
    window.dispatchEvent(new CustomEvent('admin-token-refreshed', {
      detail: {
        token: data.token,
        token_expires_at: data.token_expires_at || '',
      },
    }))
  } catch (_) {}
  return data.token
}

export async function redirectToLogin() {
  if (redirectingToLogin) return
  redirectingToLogin = true
  removeToken()
  store.commit('SET_TOKEN', '')
  if (router.currentRoute.path !== '/signin') {
    try {
      await router.replace({
        path: '/signin',
        query: { redirect: router.currentRoute.fullPath },
      })
    } catch (_) {}
  }
  redirectingToLogin = false
}

export async function refreshAdminToken() {
  const token = getCurrentAdminToken()
  if (!token) {
    await redirectToLogin()
    return null
  }
  if (refreshPromise) return refreshPromise

  refreshPromise = axios.post(REFRESH_TOKEN_URL, null, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
    timeout: 60000,
    withCredentials: false,
  }).then(async response => {
    const res = response.data
    if (res?.code === 0 && res?.data?.token) {
      return applyAdminToken(res.data)
    }
    await redirectToLogin()
    return null
  }).catch(async error => {
    if (error?.response?.status === 401) {
      await redirectToLogin()
      return null
    }
    throw error
  }).finally(() => {
    refreshPromise = null
  })

  return refreshPromise
}

export async function ensureAdminTokenFresh() {
  if (!shouldRefreshAdminToken()) return getCurrentAdminToken()
  return refreshAdminToken()
}

